// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XF-Pr","rootNoMargin":"styles_rootNoMargin__2iJ9Y"};